import { render, staticRenderFns } from "./Agrofags.vue?vue&type=template&id=06c63473"
import script from "./Agrofags.vue?vue&type=script&lang=js"
export * from "./Agrofags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports